import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../../api/client";
import {
  Button,
  Icon,
  PageHeader,
  Price,
  Rating,
  Skeleton,
  Tag,
} from "../../components/ui";
import { openExternal } from "../../platform/device";
import { t } from "../../i18n";
export function VenuePage() {
  const { id } = useParams();
  const nav = useNavigate();
  const query = useQuery({
    queryKey: ["venue", id],
    queryFn: () => api.venue(id!),
    enabled: !!id,
  });
  if (query.isLoading)
    return (
      <div className="page">
        <Skeleton height={360} />
        <Skeleton height={160} />
      </div>
    );
  const v = query.data;
  if (!v) return <div className="page">Place not found.</div>;
  return (
    <div className="venue-page">
      <div
        className="venue-hero"
        style={{
          backgroundImage: `linear-gradient(180deg,rgba(18,67,62,.04),rgba(17,60,56,.82)),url(${v.image})`,
        }}
      >
        <PageHeader back={() => nav(-1)} title="" />
        <div>
          <Tag tone="accent">
            {v.activityCategories[0]?.replaceAll("_", " ")}
          </Tag>
          <h1>{v.venueName}</h1>
          <p>
            {v.branchName} · {v.area}
          </p>
        </div>
      </div>
      <div className="page venue-details">
        <div className="row row--between">
          {v.rating > 0 && <Rating value={v.rating} />}
          <Price band={v.priceBand} />
          <Tag tone={v.isOpen ? "success" : "neutral"}>
            {v.isOpen ? "Open now" : "Check hours"}
          </Tag>
        </div>
        <p>{v.description}</p>
        <div className="info-grid">
          <div>
            <small>AGE</small>
            <strong>
              {v.minimumAge > 0 ? `${v.minimumAge}+` : "All ages"}
            </strong>
          </div>
          <div>
            <small>BOOKING</small>
            <strong>
              {v.hasRequestToBook
                ? `Request · $${(v.depositMinor / 100).toFixed(0)} deposit`
                : "Walk-in / none required"}
            </strong>
          </div>
        </div>
        <section>
          <h2>Opening hours</h2>
          {v.openingHours.map((hours) => (
            <p key={hours}>{hours}</p>
          ))}
        </section>
        <section>
          <h2>Amenities</h2>
          <div className="row row--wrap">
            {v.amenities.map((amenity) => (
              <Tag key={amenity}>{amenity}</Tag>
            ))}
          </div>
        </section>
        <section>
          <h2>Booking and cancellation</h2>
          <p>{v.cancellationPolicy}</p>
        </section>
        <Button
          variant="secondary"
          onClick={() =>
            void openExternal(
              `https://www.google.com/maps/search/?api=1&query=${v.latitude},${v.longitude}`,
            )
          }
        >
          <Icon name="location" /> Get directions
        </Button>
        <div className="sticky-action">
          {v.hasRequestToBook ? (
            <>
              <Button onClick={() => nav(`/venues/${v.id}/reserve`)}>
                {t.directBooking.title}
              </Button>
              <small>{t.directBooking.independent}</small>
            </>
          ) : (
            <div className="notice">
              <strong>{t.directBooking.notRequired}</strong>
              <p>{v.cancellationPolicy}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
